import { render, staticRenderFns } from "./turnIntroduce.vue?vue&type=template&id=a4253ae6&scoped=true&"
import script from "./turnIntroduce.vue?vue&type=script&lang=js&"
export * from "./turnIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./turnIntroduce.vue?vue&type=style&index=0&id=a4253ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4253ae6",
  null
  
)

export default component.exports